"use client";

import { useT } from "@/app/translations/useT";
import { UStyles } from "@/app/utils/UStyles";
import { BLOG_CATEGORIES } from "./BlogCategories.logic";
import styles from "./BlogCategories.module.css";

type Props = {
  activeId: string;
  onSelect: (id: string) => void;
};

export default function BlogCategories(props: Props) {
  const T = useT();
  const { activeId, onSelect } = props;

  return (
    <div className={styles.container}>
      {BLOG_CATEGORIES.map((item) => (
        <button
          key={item.id}
          type="button"
          disabled={item.disabled}
          className={UStyles.classNames(
            styles.chip,
            activeId === item.id ? styles.chipActive : "",
            item.disabled ? styles.chipDisabled : "",
          )}
          onClick={() => onSelect(item.id)}
        >
          {T(item.labelKey)}
        </button>
      ))}
    </div>
  );
}
